export const pdp = {
  methods: {
    //---- SWITCH THE VARIANT
    switchVariant(color, size) {
      //determine if we are updating size or color
      if (color !== this.selectedColor) {
        //we're changing color, scroll to back to first image (but not on allpas due to CRO test)
        //This behavior has been commented out for a DY test
        //if (!this.product.title.includes('Allpa')) {
        //this.scrollToTop();
        //}
        this.slideSwipers(0);
        //update selected color to new color
        this.selectedColor = color;
        //update selected size to size data that corresponds to new color
        this.selectedSize = this.selectedColor.sizes.find(
          (sz) => sz.name === this.selectedSize.name
        );
        //check that new variant has same size options as previous variant
        if (!this.selectedSize) {
          this.selectedSize = color.sizes.find((size) => size.available);
        }
      } else if (size !== this.selectedSize) {
        //color is not being updated - we just need to update size
        this.selectedSize = size;
      }
      //update selected variant and selected variant ID for cart
      this.selectedVariantID = this.selectedSize.shopifyVariantId;
      //update variant param in URL
      this.updateUrl();

      this.selectedVariant = {
        shopifyProductId: this.productId,
        sku: this.selectedSize.sku,
        title: this.selectedSize.title,
        shopifyVariantId: this.selectedSize.shopifyVariantId,
        barcode: this.selectedSize.barcode,
        price: this.selectedSize.price,
        colorName: this.selectedSize.colorName,
        size: this.selectedSize.name,
        inventoryCount: this.selectedSize.available,
        status: this.selectedColor.status,
      };

      //update model info on new colorway images
      if (this.selectedColor.images.length > 0) {
        this.updateModelInfo(this.selectedColor.images[0].alt);
      }
      this.getSelectedVariantPrice();

      //updates Klarna payment amount if new variant is different price
      document
        .getElementsByTagName('klarna-placement')[0]
        .setAttribute(
          'data-purchase-amount',
          (this.selectedVariant.price * 100).toString()
        );
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    },
    //scroll from mini stars at top of pdp to top of reviews section bottom of pdp
    scrollToReviews() {
      const yOffset = -60;
      const element = document.getElementById('ctpx-yotpo-sec');
      const y = element.getBoundingClientRect().top + window.scrollY + yOffset;

      window.scrollTo({ top: y, behavior: 'smooth' });
    },
    //finds price for selected variant and adjusts for different pricing at different size variants
    getSelectedVariantPrice() {
      this.selectedVariantPrice = this.selectedSize.price;
    },

    //---- UPDATE THE URL
    updateUrl() {
      let params = new URLSearchParams(location.search);
      if (location.search.includes('colorway')) {
        params.delete('colorway');
      }
      params.set('variant', this.selectedVariantID);
      window.history.replaceState({}, '', `${location.pathname}?${params}`);
    },
  },
};
